import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
		theme: {
			themes: {
				light: {
					primary: "#ff922e",
					secondary: "#824003",
					inputButton: "#969696",
					rowback: "#e7ebee",
				}
			}
		}
});
